import { FC, useId } from 'react'

import { Icon } from '../Icon'

import { StarProps } from './types'

export const Star: FC<StarProps> = ({
  maskPercentage,
  filledColor,
  emptyColor,
  filled,
  ...props
}) => {
  const maskId = useId()
  const hasMask = maskPercentage !== undefined

  return (
    <Icon width="14" height="14" viewBox="0 0 16 16" fill="none" {...props}>
      {hasMask && (
        <defs>
          <mask
            id={maskId}
            data-testid="star-mask"
            data-mask-percentage={maskPercentage}
          >
            <rect x="0" y="0" width="16" height="16" fill="black" />
            <rect
              x="0"
              y="0"
              width={`${maskPercentage}%`}
              height="16"
              fill="white"
            />
          </mask>
        </defs>
      )}
      <path
        d="M16 6.11115L10.1863 5.71409L7.99681 0L5.80734 5.71409L0 6.11115L4.45419 10.0401L2.99256 16L7.99681 12.714L13.0011 16L11.5395 10.0401L16 6.11115Z"
        fill={emptyColor}
      />
      {filled && (
        <path
          d="M16 6.11115L10.1863 5.71409L7.99681 0L5.80734 5.71409L0 6.11115L4.45419 10.0401L2.99256 16L7.99681 12.714L13.0011 16L11.5395 10.0401L16 6.11115Z"
          fill={filledColor}
          {...(hasMask && { mask: `url(#${maskId})` })}
        />
      )}
    </Icon>
  )
}
